// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__3IBEj","cell":"ColumnAccessor_cell__26WkV","firstCellAccent":"ColumnAccessor_firstCellAccent__1FL1v"};